import request from "../request";
import { AxiosResponse } from "axios";
import {
  LoginForm,
  CodeLoginForm,
  MenuForm,
  LoginConfig,
} from "@/types/views/login";
import { ResponseData } from "@/types/api/public";
import { LoginSuccess, UserInfo, LoginConfigSuccess } from "@/types/api/login";
import { WS_TRUCK } from "./prefix";
type ConfigType<T = ResponseData> = Promise<AxiosResponse<T>>;

const host = "";

/**
 * @desc: 登录
 * @param { Object } data 输入的账号密码
 */
export const login = (data: LoginForm): ConfigType<LoginSuccess> => {
  return request({
    url: `/api/iam-auth-web/auth/login/account/password/login`,
    method: "post",
    data,
  });
};

export const codeLogin = (data: CodeLoginForm): ConfigType<LoginSuccess> => {
  return request({
    url: `/api/iam-auth-web/auth/login4Wx/wxWorkQr/login`,
    method: "post",
    data,
  });
};

/**
 * @desc: 获取门户登录配置信息
 * @param { Object } data 输入的账号密码
 */
export const getLoginConfig = (
  data: LoginConfig
): ConfigType<LoginConfigSuccess> => {
  return request({
    url: `/api/iam-auth-web/auth/login4Wx/wxWorkQr/config`,
    method: "post",
    data,
  });
};

/**
 * @desc: 获取用户信息
 * @returns data
 */
export const info = (): ConfigType<UserInfo> => {
  return request({
    url: `/api/iam-auth-web/auth/user/token/userInfo`,
    method: "post",
  });
};

/**
 * @desc: 获取菜单
 */
export const menu = (data: MenuForm) => {
  return request({
    url: `/api/iam-auth-web/auth/user/user/menu/list`,
    method: "get",
    params: data,
  });
};

/**
 * @desc: 退出登录
 */
export const logout = (): any => {
  return Promise.resolve();
};

/**
 * @desc: 获取loginToken
 */
export const getLoginToken = () => {
  return request(
    {
      url: `/api${WS_TRUCK}/jwt/token`,
      method: "get",
    },
    {
      headers: {
        "X-Requested-By": "eshipping",
        Authorization: null,
        withCredentials: true,
      },
    }
  );
};

/**
 * @desc: 顺风车token
 */
export const getLoginHarbour = (data: any) => {
  return request({
    url: `/api/hitch-ride-server/user/loginHarbour`,
    method: "post",
    data,
  });
};

/**
 * @desc: cookie跨域
 */
export const getCookie = (data?: any) => {
  return request({
    url: `/api/iam-auth-web/auth/user/get/harbour/session`,
    method: "get",
    headers: {
      withCredentials: true,
    },
    data,
  });
};

export const postRetrieveUrl = (data?: any) => {
  return request({
    url: "/api/iam-auth-web/auth/user/reset/pwd/url",
    method: "post",
    headers:{
      'X-Tenant-Id': import.meta.env.VITE_X_TENANT_ID
    },
    data,
  });
};

export const apiGetHarbourUserInfo = () => {
  return request({
    url: "/api/harbour-server/user/current",
    method: "get",
  });
};

export const getRefreshToken = () => {
  return request({
    url: "/api/iam-auth-web/auth/user/renewal/token",
    method: "get",
  });
};

export const getRefreshSession=()=>{
  return request({
    url:"/api/harbour-server/jwt/refreshSession"
  })
}
